import { Alert } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

const Error = () => {
  const { t } = useTranslation();
  const useQuery = () => new URLSearchParams(useLocation().search);
  return (
    <Alert variant="error" margin="small">
      {t("errorPage." + (useQuery().get("type") || "general"))}
    </Alert>
  );
};

export default Error;
